import { useLocation, useNavigate } from 'react-router-dom'
import Navbar from 'components/Navbar'
import './App.css'
import { useSetup } from 'hooks/useSetup'
import background from 'assets/images/background.webp'
import Footer from 'components/Footer'
import AppRoutes from 'Routes'
import { observer } from 'mobx-react-lite'
import { RouteName } from 'constants/constants'
import { accountStore } from 'stores'
import React, { useEffect } from 'react'
import Loading from 'views/loading'
import { Box } from '@mui/system'
import ReactGA from 'react-ga'

if (typeof window !== 'undefined') {
  ReactGA.initialize(process.env.REACT_APP_GA as string)
  ReactGA.pageview(window.location.pathname + window.location.search)
}

const App = observer(() => {
  const { isReady } = useSetup()
  const { eligible } = accountStore
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (eligible && pathname === RouteName.default) {
      navigate(RouteName.pool)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligible])

  return (
    <>
      <Loading isLoading={!isReady} />
      <Box
        sx={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        }}
      >
        <Navbar />
        <AppRoutes />
        <Footer />
      </Box>
    </>
  )
})

export default App
